import { useState } from 'react';
import { Box, Dialog, Stack, styled } from '@mui/material';
import { useSnackbar } from 'notistack';
import useLocales from '../../../../hooks/useLocales';

import { useDispatch, useSelector } from '../../../../redux/store';
import { openLoginSignup } from '../../../../redux/slices/authPages';

import Login from './Login';
import Image from '../../../../components/Image';
import useAuth from '../../../../hooks/useAuth';

import Iconify from '../../../../components/Iconify';

// STYLES
const DialogBoxContentContainer = styled(Box)({
  backgroundColor: '#003C79',
  height: 'auto',
  width: '90vw',
  maxWidth: '825px',
  overflow: 'auto',
  margin: 'auto',
  padding: '0!important',
  boxShadow: '0 1px 2px -2px rgba(0,0,0,.64),0 3px 6px 0 rgba(0,0,0,.48),0 5px 12px 4px rgba(0,0,0,.36)',
  position: 'relative',
  // borderRadius: '20px 20px 0 0',
  // border: '1px solid #F0C335',
});

const DialogHeaderContainer = styled(Stack)({
  padding: '16px 24px',
  color: '#F0C335',
  background: '#1E662E'
});

const CloseButton = styled(Iconify)({
  cursor: 'pointer',
});

const DialogMainContentContainer = styled(Stack)(({ theme }) => ({
  color: '#fff',
  background: '#EEEEEE',
  [theme.breakpoints.up('xs')]: {
    padding: '12px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '35px 48px',
  },
}));
// STYLES

const LoginSignupDialog = ({ setOpenForgotPasswordDialog }) => {
  const { login } = useAuth();

  const dispatch = useDispatch();

  const { isOpenLoginSignupDialog } = useSelector((x) => x.authPages);

  const [activeTab, setActiveTab] = useState('1');

  const [authData, setAuthData] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const { translate } = useLocales();

  return (
    <Dialog
      hasClose={false}
      maxWidth={'lg'}
      open={isOpenLoginSignupDialog.open}
      onClose={() => dispatch(openLoginSignup({ open: false, isLogin: true }))}
      PaperProps={{ sx: { borderRadius: '20px 20px 0 0', margin: 0 } }}
    >
      <DialogBoxContentContainer>
        <DialogHeaderContainer direction={'row'} justifyContent={'space-between'}>
          <Image src={require('../../../../assets/brand-logo.png')} sx={{ maxWidth: '120px'}} />
          {/* <Typography>{translate('welcome_to_bk')}</Typography> */}
          <CloseButton
            icon={'ep:close'}
            width={24}
            height={24}
            sx={{ cursor: 'pointer', color: '#fff' }}
            onClick={() => dispatch(openLoginSignup({ open: false, isLogin: true }))}
          />
        </DialogHeaderContainer>
        <DialogMainContentContainer>
          <Login
            setOpenForgotPasswordDialog={setOpenForgotPasswordDialog}
            setActiveTab={setActiveTab}
            setAuthData={setAuthData}
          />
        </DialogMainContentContainer>
      </DialogBoxContentContainer>
    </Dialog>
  );
};

export default LoginSignupDialog;
